module.exports = __webpack_public_path__ + "components/incentive/static/incentive-mobile-d5d9f000791e3935d39381cdb6a60be8.webp";